module.exports = __webpack_public_path__ + "images/emoji/scream_cat.8a420c5a2ecf80c204b6.png";